<template>
	<div class="container" v-if="list.length >0">
    <div class="panel panel-default ">
        <div class="panel-heading">
            <div class="category">
                <a class="category-top">{{name}}</a>
                <a class="category-bottom">{{enname}}</a>
            </div>
        </div>
        <div class="panel-body" style="padding:0px; margin: 4px 8px">
                <div class="panel panel-default bor" v-for="(item, index) in list">
                    <div class="panel-heading facility left_bor">
                        
                        <h4 style="color:#4b1c0f">{{item.name}}</h4>
                    </div>
                    <div class="panel-body facility-body right_bor" v-if="item.list.length >0">
                        <div class="row">
                            <div class="lirow bs" v-for="val in item.list"> 
                                <img src="../../assets/images/bs.png" alt="">
                                &nbsp;&nbsp;{{val.FacilityName}}</div>
                        </div>
                    </div>
                </div>
                

        </div>
    </div>
</div>
</template>

<script>

export default {
  data(){
    return {
      show: false,
    }
  },
  props: {
  	list: {
  		type: Array||Object,
  		require: true
  	},
  	name: {
  		type: String,
  		default: '设施服务'
  	},
  	enname: {
  		type: String,
  		default: 'Facilities Service'
  	}
  },
  components: {  },
  mounted: function () {
  },
  methods: {
  }
};

</script>
<style>
    .bor{
        box-shadow: none;
        border: 1px solid #f44103;
        display: flex;
        overflow: hidden;
    }
    .left_bor{
        max-width: 40px;
        text-align: center;
        border-right: 1px solid #f44103;
        padding: 10px 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffe4db!important;
        border-radius: 6px;
    }
    .right_bor{
        width: 100%;
        padding: 6px;
    }
    .bs{
        width: 33%;
        display: flex;
        align-items: center;
    }
    .bs img{
        width: 14px;
        height: 14px;
        margin-right: 2%;
    }
</style>

